// src/components/InstallPromptModal.js
import React from "react";

const InstallPromptModal = ({ onInstall, onClose }) => {
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Install App</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>Would you like to install this app?</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={onInstall}>Yes, Install</button>
            <button className="btn btn-secondary" onClick={onClose}>Later</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstallPromptModal;
